import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { Sweep } from '@/components/ui/States';
import { LoginPage } from '@/features/auth/LoginPage';
import { useSession } from '@/features/auth/session';
import { FeedPage } from '@/features/feed/FeedPage';
import { TargetsPage } from '@/features/targets/TargetsPage';
import { ArchivePage } from '@/features/archive/ArchivePage';
import { DeletedPage } from '@/features/deleted/DeletedPage';
import { DigestPage } from '@/features/digest/DigestPage';

function Booting() {
  return (
    <div className="flex h-dvh flex-col items-center justify-center gap-4">
      <span className="font-mono text-sm tracking-[0.3em] text-ink-dim">BIG BROTHER</span>
      <Sweep className="w-40" />
    </div>
  );
}

function RequireAuth() {
  const session = useSession();

  if (session.isPending) return <Booting />;
  if (!session.data) return <Navigate to="/login" replace />;
  return <AppShell />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route path="/feed" element={<FeedPage />} />
        <Route path="/digest" element={<DigestPage />} />
        <Route path="/targets" element={<TargetsPage />} />
        <Route path="/deleted" element={<DeletedPage />} />
        <Route path="/archive" element={<ArchivePage />} />
      </Route>
      <Route path="*" element={<Navigate to="/feed" replace />} />
    </Routes>
  );
}
